import HomePage from '@/pages/public/home-page/HomePage'
import RegisterGridPage from '@/pages/public/register-grid-page/RegisterGridPage'
import WhoWeArePage from '@/pages/public/who-we-are-page/WhoWeArePage'
import HowWeEmergedPage from '@/pages/public/how-we-emerged-page/HowWeEmergedPage'
import ForWhomPage from '@/pages/public/for-whom-page/ForWhomPage'
import TermsUsePage from '@/pages/public/terms-use-page/TermsUsePage'
import PrivacyPolicy from '@/pages/public/privacy-policy/PrivacyPolicy'
import LandingPage from '@/pages/public/landing-page/LandingPage'
import LoginRecoverRegisterPage from '@/pages/public/login-recover-register-page/LoginRecoverRegisterPage'
import LoginForm from '@/components/login-form/LoginForm'
import RecoverPasswordForm from '@/components/recover-password-form/RecoverPasswordForm'
import RegisterForm from '@/components/register-form/RegisterForm'
import NewPasswordForm from '@/components/new-password-form/NewPasswordForm'
import FirstInformationForm1 from '@/components/register-first-information-forms/FirstInformationForm1'
import FirstInformationForm2 from '@/components/register-first-information-forms/FirstInformationForm2'
import FirstInformationForm3 from '@/components/register-first-information-forms/FirstInformationForm3'
import AboutLegalGuardianForm1 from '@/components/register-about-legal-guardian/AboutLegalGuardianForm1'
import AboutLegalGuardianForm2 from '@/components/register-about-legal-guardian/AboutLegalGuardianForm2'
import AboutLegalGuardianForm3 from '@/components/register-about-legal-guardian/AboutLegalGuardianForm3'
import AboutInitiativeForm1 from '@/components/register-about-initiative-forms/AboutInitiativeForm1'
import AboutInitiativeForm2 from '@/components/register-about-initiative-forms/AboutInitiativeForm2'
import AboutInitiativeForm3 from '@/components/register-about-initiative-forms/AboutInitiativeForm3'
import AboutInitiativeForm4 from '@/components/register-about-initiative-forms/AboutInitiativeForm4'
import AboutInitiativeForm5 from '@/components/register-about-initiative-forms/AboutInitiativeForm5'
import AboutInitiativeForm6 from '@/components/register-about-initiative-forms/AboutInitiativeForm6'
import AboutInitiativeForm7 from '@/components/register-about-initiative-forms/AboutInitiativeForm7'
import AboutInitiativeForm8 from '@/components/register-about-initiative-forms/AboutInitiativeForm8'
import AboutInitiativeForm9 from '@/components/register-about-initiative-forms/AboutInitiativeForm9'
import AboutInitiativeForm10 from '@/components/register-about-initiative-forms/AboutInitiativeForm10'
import AboutInitiativeForm11 from '@/components/register-about-initiative-forms/AboutInitiativeForm11'
import AboutInitiativeForm12 from '@/components/register-about-initiative-forms/AboutInitiativeForm12'
import AboutInitiativeForm13 from '@/components/register-about-initiative-forms/AboutInitiativeForm13'
import AboutInitiativeForm14 from '@/components/register-about-initiative-forms/AboutInitiativeForm14'
import ManagementPlanningForm1 from '@/components/register-management-planning-forms/ManagementPlanningForm1'
import ManagementPlanningForm2 from '@/components/register-management-planning-forms/ManagementPlanningForm2'
import FinancialSustainabilityForm1 from '@/components/register-financial-sustainability/FinancialSustainabilityForm1'
import NetworksPartnersForm1 from '@/components/register-networks-partners-forms/NetworksPartnersForm1'
import ResultsImpactsForm1 from '@/components/register-results-impacts-forms/ResultsImpactsForm1'
import GovernanceForm1 from '@/components/register-governance-forms/GovernanceForm1'
import GovernanceForm2 from '@/components/register-governance-forms/GovernanceForm2'
import GovernanceForm3 from '@/components/register-governance-forms/GovernanceForm3'
import GovernanceForm4 from '@/components/register-governance-forms/GovernanceForm4'
import GovernanceForm5 from '@/components/register-governance-forms/GovernanceForm5'
import GovernanceForm6 from '@/components/register-governance-forms/GovernanceForm6'
import GovernanceForm7 from '@/components/register-governance-forms/GovernanceForm7'
import GovernanceForm8 from '@/components/register-governance-forms/GovernanceForm8'
import GovernanceForm9 from '@/components/register-governance-forms/GovernanceForm9'
import GovernanceForm10 from '@/components/register-governance-forms/GovernanceForm10'
import AttachmentsForm1 from '@/components/register-attachments-forms/AttachmentsForm1'
import DashboardGridPage from '@/pages/private/dashboard-page/DashboardGridPage'
import OpportunityPanel from '@/pages/private/dashboard-page/opportunity-panel/OpportunityPanel'
import ConnectionsPage from '@/pages/private/dashboard-page/connections-page/ConnectionsPage'
import MyProfilePage from '@/pages/private/dashboard-page/my-profile-page/MyProfilePage'
import MessagesPage from '@/pages/private/dashboard-page/messages-page/MessagesPage'
import BenefitsPage from '@/pages/private/dashboard-page/benefits-page/BenefitsPage'
import DashboardAdminGridPage from '@/pages/private/dashboard-admin-grid-page/DashboardAdminGridPage'
import DashboardAdminPage from '@/pages/private/dashboard-admin-grid-page/dashboard-admin-page/DashboardAdminPage'
import UsersAdminPage from '@/pages/private/dashboard-admin-grid-page/users-admin-page/UsersAdminPage'
import EditPagesAdmin from '@/pages/private/dashboard-admin-grid-page/edit-pages-admin/EditPagesAdmin'
import ProfileAdminPage from '@/pages/private/dashboard-admin-grid-page/profile-admin-page/ProfileAdminPage'
import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            component: LandingPage,
            children: [
                {
                    path: '/',
                    name: 'HomePage',
                    component: HomePage
                },
                {
                    path: '/quem-somos',
                    name: 'WhoWeArePage',
                    component: WhoWeArePage
                },
                {
                    path: '/como-surgimos',
                    name: 'HowWeEmergedPage',
                    component: HowWeEmergedPage
                },
                {
                    path: '/para-quem-e',
                    name: 'ForWhomPage',
                    component: ForWhomPage
                },
                {
                    path: '/politica-de-privacidade',
                    name: 'PrivacyPolicy',
                    component: PrivacyPolicy
                },
                {
                    path: '/termos-de-uso',
                    name: 'TermsUsePage',
                    component: TermsUsePage
                },
                {
                    path: 'beneficios',
                    name: 'BenefitsPage',
                    component: BenefitsPage
                }
            ]
        },
        {
            path: '/',
            component: LoginRecoverRegisterPage,
            children: [
                {
                    path: 'login',
                    name: 'LoginForm',
                    component: LoginForm
                },
                {
                    path: 'recuperarsenha',
                    name: 'RecoverPassword',
                    component: RecoverPasswordForm
                },
                {
                    path: 'nova-senha',
                    name: 'NewPasswordForm',
                    component: NewPasswordForm,
                    children: [
                        { path: ':email/:code', name: 'NewPasswordByEmail', component: ConnectionsPage }
                    ]
                },
                {
                    path: 'cadastrar',
                    name: 'Register',
                    component: RegisterForm
                }
            ]
        },
        {
            path: '/admin',
            component: LoginRecoverRegisterPage,
            redirect: { name: 'LoginAdminForm' },
            children: [
                {
                    path: 'login',
                    name: 'LoginAdminForm',
                    component: LoginForm
                }
            ]
        },
        {
            path: '/admin/plataforma-adm',
            name: 'DashboardAdminGridPage',
            component: DashboardAdminGridPage,
            redirect: { name: 'DashboardAdminPage' },
            children: [
                {
                    path: '/',
                    name: 'DashboardAdminPage',
                    component: DashboardAdminPage
                },
                {
                    path: 'usuarios',
                    name: 'UsersAdminPage',
                    component: UsersAdminPage
                },
                {
                    path: 'edit-pages',
                    name: 'EditPagesAdmin',
                    component: EditPagesAdmin
                },
                {
                    path: 'investidores',
                    name: 'InvestorsAdminPage',
                    component: ProfileAdminPage
                },
                {
                    path: 'iniciativas',
                    name: 'InitiativesAdminPage',
                    component: ProfileAdminPage
                },
                {
                    path: 'prestadores-de-servico',
                    name: 'SupportersAdminPage',
                    component: ProfileAdminPage
                }
            ]
        },
        {
            path: '/plataforma',
            name: 'DashboardGridPage',
            component: DashboardGridPage,
            redirect: { name: 'OpportunityPanel' },
            children: [
                {
                    path: '/',
                    name: 'OpportunityPanel',
                    component: OpportunityPanel
                },
                {
                    path: 'conexoes',
                    name: 'ConnectionsPage',
                    component: ConnectionsPage,
                    children: [
                        { path: ':userId/:connectionId/:opt', name: 'CancelRequestEmailConnectionPage', component: ConnectionsPage },
                        { path: ':userId/:compatibility', name: 'NewRequestEmailConnectionPage', component: ConnectionsPage }
                    ]
                },
                {
                    path: 'meu-perfil',
                    name: 'MyProfilePage',
                    component: MyProfilePage
                },
                {
                    path: 'mensagens',
                    name: 'MessagesPage',
                    component: MessagesPage
                }
            ]
        },
        {
            path: '/cadastro',
            name: 'RegisterGridPage',
            component: RegisterGridPage,
            redirect: { name: 'FirstInformationForm1' },
            children: [
                {
                    path: 'primeiras-informacoes/1',
                    name: 'FirstInformationForm1',
                    component: FirstInformationForm1
                },
                {
                    path: 'primeiras-informacoes/2',
                    name: 'FirstInformationForm2',
                    component: FirstInformationForm2
                },
                {
                    path: 'primeiras-informacoes/3',
                    name: 'FirstInformationForm3',
                    component: FirstInformationForm3
                },
                {
                    path: 'responsavel/1',
                    name: 'AboutLegalGuardianForm1',
                    component: AboutLegalGuardianForm1
                },
                {
                    path: 'responsavel/2',
                    name: 'AboutLegalGuardianForm2',
                    component: AboutLegalGuardianForm2
                },
                {
                    path: 'responsavel/3',
                    name: 'AboutLegalGuardianForm3',
                    component: AboutLegalGuardianForm3
                },
                {
                    path: 'sobre-organizacao/1',
                    name: 'AboutInitiativeForm1',
                    component: AboutInitiativeForm1
                },
                {
                    path: 'sobre-organizacao/2',
                    name: 'AboutInitiativeForm2',
                    component: AboutInitiativeForm2
                },
                {
                    path: 'sobre-organizacao/3',
                    name: 'AboutInitiativeForm3',
                    component: AboutInitiativeForm3
                },
                {
                    path: 'sobre-organizacao/4',
                    name: 'AboutInitiativeForm4',
                    component: AboutInitiativeForm4
                },
                {
                    path: 'sobre-organizacao/5',
                    name: 'AboutInitiativeForm5',
                    component: AboutInitiativeForm5
                },
                {
                    path: 'sobre-organizacao/6',
                    name: 'AboutInitiativeForm6',
                    component: AboutInitiativeForm6
                },
                {
                    path: 'sobre-organizacao/7',
                    name: 'AboutInitiativeForm7',
                    component: AboutInitiativeForm7
                },
                {
                    path: 'sobre-organizacao/8',
                    name: 'AboutInitiativeForm8',
                    component: AboutInitiativeForm8
                },
                {
                    path: 'sobre-organizacao/9',
                    name: 'AboutInitiativeForm9',
                    component: AboutInitiativeForm9
                },
                {
                    path: 'sobre-organizacao/10',
                    name: 'AboutInitiativeForm10',
                    component: AboutInitiativeForm10
                },
                {
                    path: 'sobre-organizacao/11',
                    name: 'AboutInitiativeForm11',
                    component: AboutInitiativeForm11
                },
                {
                    path: 'sobre-organizacao/12',
                    name: 'AboutInitiativeForm12',
                    component: AboutInitiativeForm12
                },
                {
                    path: 'sobre-organizacao/13',
                    name: 'AboutInitiativeForm13',
                    component: AboutInitiativeForm13
                },
                {
                    path: 'sobre-organizacao/14',
                    name: 'AboutInitiativeForm14',
                    component: AboutInitiativeForm14
                },
                {
                    path: 'planejamento-gestao/1',
                    name: 'ManagementPlanningForm1',
                    component: ManagementPlanningForm1
                },
                {
                    path: 'planejamento-gestao/2',
                    name: 'ManagementPlanningForm2',
                    component: ManagementPlanningForm2
                },
                {
                    path: 'sustentabilidade-financeira/1',
                    name: 'FinancialSustainabilityForm1',
                    component: FinancialSustainabilityForm1
                },
                {
                    path: 'redes-parceiros/1',
                    name: 'NetworksPartnersForm1',
                    component: NetworksPartnersForm1
                },
                {
                    path: 'resultados-impactos/1',
                    name: 'ResultsImpactsForm1',
                    component: ResultsImpactsForm1
                },
                {
                    path: 'governanca/1',
                    name: 'GovernanceForm1',
                    component: GovernanceForm1
                },
                {
                    path: 'governanca/2',
                    name: 'GovernanceForm2',
                    component: GovernanceForm2
                },
                {
                    path: 'governanca/3',
                    name: 'GovernanceForm3',
                    component: GovernanceForm3
                },
                {
                    path: 'governanca/4',
                    name: 'GovernanceForm4',
                    component: GovernanceForm4
                },
                {
                    path: 'governanca/5',
                    name: 'GovernanceForm5',
                    component: GovernanceForm5
                },
                {
                    path: 'governanca/6',
                    name: 'GovernanceForm6',
                    component: GovernanceForm6
                },
                {
                    path: 'governanca/7',
                    name: 'GovernanceForm7',
                    component: GovernanceForm7
                },
                {
                    path: 'governanca/8',
                    name: 'GovernanceForm8',
                    component: GovernanceForm8
                },
                {
                    path: 'governanca/9',
                    name: 'GovernanceForm9',
                    component: GovernanceForm9
                },
                {
                    path: 'governanca/10',
                    name: 'GovernanceForm10',
                    component: GovernanceForm10
                },
                {
                    path: 'anexos/1',
                    name: 'AttachmentsForm1',
                    component: AttachmentsForm1
                }
            ]
        },
        {
            path: '*',
            redirect: '/'
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        return window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }
})

const openFlowFirstRegisterRoutes = [
    'FirstInformationForm1',
    'FirstInformationForm2'
]

const openFlowRegisterRoutes = [
    'AboutLegalGuardianForm1',
    'AboutLegalGuardianForm2',
    'AboutLegalGuardianForm3',
    'AboutInitiativeForm1',
    'AboutInitiativeForm2',
    'AboutInitiativeForm3',
    'AboutInitiativeForm4',
    'AboutInitiativeForm5',
    'AboutInitiativeForm6',
    'AboutInitiativeForm7',
    'AboutInitiativeForm8',
    'AboutInitiativeForm9',
    'AboutInitiativeForm10',
    'AboutInitiativeForm11',
    'AboutInitiativeForm12',
    'AboutInitiativeForm13',
    'AboutInitiativeForm14',
    'ManagementPlanningForm1',
    'ManagementPlanningForm2',
    'FinancialSustainabilityForm1',
    'NetworksPartnersForm1',
    'ResultsImpactsForm1',
    'GovernanceForm1',
    'GovernanceForm2',
    'GovernanceForm3',
    'GovernanceForm4',
    'GovernanceForm5',
    'GovernanceForm6',
    'GovernanceForm7',
    'GovernanceForm8',
    'GovernanceForm9',
    'GovernanceForm10',
    'AttachmentsForm1'
]

const platformRoutes = [
    'OpportunityPanel',
    'ConnectionsPage',
    'CancelRequestEmailConnectionPage',
    'NewRequestEmailConnectionPage',
    'MyProfilePage',
    'MessagesPage'
]

const adminPlatformRoutes = [
    'DashboardAdminPage',
    'UsersAdminPage',
    'EditPagesAdmin',
    'InvestorsAdminPage',
    'InitiativesAdminPage',
    'SupportersAdminPage'
]

router.beforeEach((to, from, next) => {
    if ([
        'DashboardGridPage',
        'LoginForm',
        'WhoWeArePage',
        'HomePage',
        'HowWeEmergedPage',
        'ForWhomPage',
        'PrivacyPolicy',
        'TermsUsePage'
    ].includes(to.name)) {
        localStorage.removeItem('authentication-admin')
    }

    if (to.name === 'Register') {
        localStorage.getItem('usuario') ? next({ name: 'DashboardGridPage' }) : next()
    } else if (platformRoutes.includes(to.name)) {
        localStorage.getItem('usuario') ? next() : next({ name: 'LoginForm' })
    } else if (to.name === 'LoginForm' && localStorage.getItem('usuario')) {
        next({ name: 'DashboardGridPage' })
    } else if (to.name === 'FirstInformationForm3') {
        if (localStorage.getItem('usuario')) {
            next({ name: 'AboutInitiativeForm1' })
        } else if (localStorage.getItem('firstInfo')) {
            next()
        } else {
            next({ name: 'LoginForm' })
        }
    } else if (openFlowFirstRegisterRoutes.includes(to.name) && !localStorage.getItem('usuario') && !localStorage.getItem('firstInfo')) {
        next({ name: 'LoginForm' })
    } else if (openFlowRegisterRoutes.includes(to.name) && !localStorage.getItem('usuario')) {
        next({ name: 'LoginForm' })
    } else if (adminPlatformRoutes.includes(to.name)) {
        if (localStorage.getItem('usuario')) {
            localStorage.removeItem('usuario')
            next({ name: 'LoginAdminForm' })
        } else {
            if (localStorage.getItem('authentication-admin')) {
                next()
            } else {
                next({ name: 'LoginAdminForm' })
            }
        }
    } else if (to.name === 'LoginAdminForm' && localStorage.getItem('usuario')) {
        next({ name: 'DashboardAdminGridPage' })
    } else {
        next()
    }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js